// main.ts
import { createApp } from 'vue';
import App from './App.vue';
import { createRouter, createWebHistory } from 'vue-router'; // Vue Routerをインポート
import HomeView from "./view/HomeView.vue";
const News20231022 = () => import("./NewsList/News20231022.vue");
const MenuList = () => import("./view/MenuList.vue");
const Cart = () => import("./view/Cart.vue");
const CustomerForm = () => import("./view/CustomerForm.vue");
const Confirmation = () => import("./view/Confirmation.vue");
const LastPage = () => import("./view/LastPage.vue");
const ContactForm = () => import("./view/ContactForm.vue");
const ReplyPage = () => import("./view/ReplyPage.vue");
const ContactConfirmation = () => import("./view/ContactConfirmation.vue");



import { createVuetify } from 'vuetify'; // Vuetifyをインポート


const NAME = "とんじき";
const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      return {
        el: to.hash,
        top: 96,
        behavior: "smooth",
      };
    }
    return { top: 0 };
  },
  routes: [
    {
      path: "/",
      name: "HomeView",
      component: HomeView,
      meta: { title: NAME },
    },
    {
      path: "/News/20231022",
      name: "News-20231022",
      component: News20231022,
      meta: { title: NAME + " | News" },
    },
    {
      path: "/menu_list",
      name: "MenuList",
      component: MenuList,
      meta: { title: NAME + " | MenuList" },
    },
    {
      path: "/cart",
      name: "ShopCart",
      component: Cart,
      meta: { title: NAME + " | Cart" },
    },
    {
      path: "/form",
      name: "CustomerForm",
      component: CustomerForm,
      meta: { title: NAME + " | Form" },
    },
    {
      path: "/confirm",
      name: "ConfirmationView",
      component: Confirmation,
      meta: { title: NAME + " | Confirmation" },
    },
    {
      path: "/thank",
      name: "LastPage",
      component: LastPage,
      meta: { title: NAME + " | Thank" },
    },
    {
      path: "/contact",
      name: "ContactForm",
      component: ContactForm,
      meta: { title: NAME + " | ContactForm" },
    },
    {
      path: "/reply",
      name: "ReplyPage",
      component: ReplyPage,
      meta: { title: NAME + " | ReplyPage" },
    },
    {
      path: "/contactconfirmation",
      name: "ContactConfirmation",
      component: ContactConfirmation,
      meta: { title: NAME + " | ContactConfirmation" },
    },
  ],
});
const vuetify = createVuetify();

createApp(App)
  .use(router) // Vue Routerを使用
  .use(vuetify) // Vuetifyを使用
  .mount('#app');
